"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const StyledRecoilUsedInput_1 = require("./styled/StyledRecoilUsedInput");
const RecentSearchBox_1 = __importDefault(require("./RecentSearchBox"));
const AutoComplete_1 = __importDefault(require("./AutoComplete"));
const ArroundSearch_1 = __importDefault(require("./common/ArroundSearch"));
const SearchModalHCountour_1 = __importDefault(require("./common/SearchModalHCountour"));
const useContextAPI_1 = require("../../hooks/useContextAPI");
const CommonDeskHeaderProvider_1 = require("../CommonDeskHeaderProvider");
const urlHandler_1 = require("../../modules/urlHandler");
const recentSearchList_1 = require("../../modules/recentSearchList");
const imageUrl_1 = require("../../resource/imageUrl");
const useAutoComplete_1 = __importDefault(require("../../hooks/useAutoComplete"));
const inputKeyDownHandler_1 = require("../../handler/autoComplete/desktop/Common/inputKeyDownHandler");
const useLog_1 = require("../../hooks/useLog");
const checkUserAgent_1 = require("../../utils/checkUserAgent");
const hangul = __importStar(require("hangul-js"));
const modalHandler_1 = require("../../handler/autoComplete/desktop/Common/modalHandler");
const searchBtnHandler_1 = __importDefault(require("../../handler/autoComplete/desktop/Common/searchBtnHandler"));
const getLocationTo_1 = __importDefault(require("../../modules/getLocationTo"));
const RecoilUsedInput = ({ input_width, setPopup, user, }) => {
    return ((0, jsx_runtime_1.jsxs)(RecoilUsedInput.Box, { input_width: input_width, children: [(0, jsx_runtime_1.jsx)(RecoilUsedInput.Modal, { setPopup: setPopup, user: user }), (0, jsx_runtime_1.jsx)(RecoilUsedInput.Input, { setPopup: setPopup }), (0, jsx_runtime_1.jsx)(RecoilUsedInput.Remove, {}), (0, jsx_runtime_1.jsx)(RecoilUsedInput.SearchBtn, { setPopup: setPopup })] }));
};
const BoxCtx = react_1.default.memo(({ children, input_width }) => {
    const { focus } = (0, useContextAPI_1.useValueContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderValueCtx);
    return ((0, jsx_runtime_1.jsx)(Box, { focus: focus, input_width: input_width, children: children }));
});
const Box = react_1.default.memo(({ children, focus, input_width, }) => {
    return ((0, jsx_runtime_1.jsx)(StyledRecoilUsedInput_1.RecoilUsedDiv, { className: "Input__Wrap", focus: focus, input_width: input_width, children: children }));
});
const ModalCtx = ({ user, setPopup, }) => {
    const { inputValue, autoValue, recentList, focus } = (0, useContextAPI_1.useValueContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderValueCtx);
    const sendLog = (0, useLog_1.useAutoCpLog)(user);
    const { setInputValue, setFocus, setRecentList, arroundSearch, setAutoValue, } = (0, useContextAPI_1.useSetContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderDispatcherCtx);
    const setPopupCallback = (0, react_1.useCallback)(() => {
        setPopup((s) => ({ ...s, noGPSPopup: true }));
    }, [setPopup]);
    const arroundSearchFn = () => {
        return arroundSearch({
            setFocus,
            setPopupCallback,
            setInputValue,
            setRecentList,
        });
    };
    const onScreenClick = (e) => {
        if (e.target === e.currentTarget) {
            (0, modalHandler_1.onEscapeAction)({
                initValue,
                inputValue,
                setAutoValue,
                setFocus,
                setInputValue,
            });
        }
        const evtTarget = e.target;
        if (evtTarget.classList && evtTarget.classList.length > 0) {
            evtTarget.classList.forEach((className) => {
                if (className.includes("Auth")) {
                    setFocus(false);
                    return;
                }
                if (className.includes("User")) {
                    setFocus(false);
                    return;
                }
            });
        }
    };
    const onEscape = (e) => {
        if (e.code === "Escape") {
            (0, modalHandler_1.onEscapeAction)({
                initValue,
                inputValue,
                setAutoValue,
                setFocus,
                setInputValue,
            });
        }
    };
    const onArroundSearch = (e) => {
        e.currentTarget.blur();
        arroundSearchFn();
        return;
    };
    const onRecentSearch = (item) => {
        if (typeof item.content !== "string")
            return;
        if (item.content.includes("주변")) {
            arroundSearchFn();
            return;
        }
        setInputValue(item.content);
        setFocus(false);
        window.location.href = (0, urlHandler_1.setQueryParams)({
            query: item.content,
            region: "",
        }, (0, getLocationTo_1.default)());
        (0, recentSearchList_1.setRecentSearchList)({ type: "query", content: item.content, query: item.content }, setRecentList);
        return;
    };
    const onAutoCompFocus = (keywordName) => {
        // 자동완성 아이템에 포커스가 갔을 때, Input의 값을 해당 키워드로 변경
        // UX 향상을 위해 값만 변경하고 실제 검색은 수행하지 않음
        setInputValue(keywordName);
    };
    const onAutoCompClick = (autoItem, from) => {
        if ("rest_id" in autoItem) {
            (0, recentSearchList_1.setRecentSearchList)({
                type: "location",
                content: autoItem,
                query: autoItem.main_name
                    ? autoItem.main_name +
                        (autoItem.branch ? " " + autoItem.branch : "")
                    : "",
                branch: autoItem.branch ? autoItem.branch : "",
            }, setRecentList);
            if (from === "AutoComp" && autoItem.rest_id) {
                sendLog({
                    inputQuery: inputValue,
                    v_rid: autoItem.rest_id ? autoItem.rest_id : "",
                });
            }
        }
        else {
            const query = autoItem.main_name || "";
            (0, recentSearchList_1.setRecentSearchList)({
                type: "query",
                content: query,
                query: query,
            }, setRecentList);
            setInputValue(query);
            setFocus(false);
            window.location.href = (0, urlHandler_1.setQueryParams)({ query: autoItem.main_name }, (0, getLocationTo_1.default)());
        }
    };
    if (focus) {
        // 자동완성 상태에 따른 UI 처리
        const isRecent = inputValue.length <= 0;
        const isNeedScroll = autoValue.rest ? autoValue.rest.length > 10 : false;
        const showArroundButton = inputValue.length === 0;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SearchScreen, { onScreenClick: onScreenClick }), (0, jsx_runtime_1.jsxs)(StyledRecoilUsedInput_1.SearchModalDiv, { className: "Search__Modal", onKeyDown: onEscape, role: "dialog", focus: focus, isRecent: isRecent, isNeedScroll: isNeedScroll, children: [showArroundButton && ((0, jsx_runtime_1.jsx)(ArroundSearch_1.default, { onArroundSearch: onArroundSearch })), (0, jsx_runtime_1.jsx)(SearchModalHCountour_1.default, {}), (0, jsx_runtime_1.jsx)(Modal, { focus: focus, inputValue: inputValue, autoValue: autoValue, recentList: recentList, setRecentList: setRecentList, onAutoCompClick: onAutoCompClick, onRecentSearch: onRecentSearch, onArroundSearch: onArroundSearch, onEscape: onEscape, onAutoCompFocus: onAutoCompFocus })] })] }));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
const SearchScreen = react_1.default.memo(({ onScreenClick }) => {
    return (0, jsx_runtime_1.jsx)(StyledRecoilUsedInput_1.SearchBgDiv, { className: "Search__Bg", onClick: onScreenClick });
});
const Modal = react_1.default.memo(({ focus, inputValue, autoValue, recentList, setRecentList, onAutoCompClick, onRecentSearch, onArroundSearch, onEscape, onAutoCompFocus, }) => {
    const isRecent = inputValue.length <= 0;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isRecent ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(RecentSearchBox_1.default, { list: recentList, setRecentList: setRecentList, onRecentSearch: onRecentSearch, onAutoCompClick: onAutoCompClick }) })) : ((0, jsx_runtime_1.jsx)(AutoComplete_1.default, { autoValue: autoValue, inputValue: inputValue, onAutoCompClick: onAutoCompClick, onRecentSearch: onRecentSearch, onAutoCompFocus: onAutoCompFocus })) }));
});
const SearchBtnCtx = ({ setPopup }) => {
    const { inputValue } = (0, useContextAPI_1.useValueContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderValueCtx);
    const { setInputValue, setFocus, setRecentList, arroundSearch } = (0, useContextAPI_1.useSetContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderDispatcherCtx);
    const setPopupCallback = (0, react_1.useCallback)(() => {
        setPopup((s) => ({ ...s, noGPSPopup: true }));
    }, [setPopup]);
    const arroundSearchFn = () => {
        return arroundSearch({
            setFocus,
            setPopupCallback,
            setInputValue,
            setRecentList,
        });
    };
    const onSearch = (e) => {
        e.currentTarget.blur();
        if (!inputValue) {
            arroundSearchFn();
            return;
        }
        (0, searchBtnHandler_1.default)({
            inputValue,
            setInputValue,
            setFocus,
            setRecentSearchList: recentSearchList_1.setRecentSearchList,
            setRecentList,
        });
        return;
    };
    return (0, jsx_runtime_1.jsx)(SearchBtn, { onSearch: onSearch });
};
const SearchBtn = react_1.default.memo(({ onSearch }) => {
    return ((0, jsx_runtime_1.jsx)(StyledRecoilUsedInput_1.SearchButton, { className: "search", onClick: onSearch, type: "button", "aria-label": "\uAC80\uC0C9\uD558\uAE30 \uBC84\uD2BC" }));
});
const initValue = (0, urlHandler_1.getQueryParams)().query;
const userAgent = (0, checkUserAgent_1.checkUserAgent)();
let checkStack = [];
let isInitAutoValue = false;
const InputCtx = ({ setPopup }) => {
    const { focus, inputValue, inputRef } = (0, useContextAPI_1.useValueContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderValueCtx);
    const { setInputValue, setAutoValue, setFocus, setRecentList, arroundSearch, } = (0, useContextAPI_1.useSetContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderDispatcherCtx);
    const { updateValue } = (0, useAutoComplete_1.default)(150, setAutoValue);
    const setPopupCallback = (0, react_1.useCallback)(() => {
        setPopup((s) => ({ ...s, noGPSPopup: true }));
    }, [setPopup]);
    const arroundSearchFn = () => {
        return arroundSearch({
            setFocus,
            setPopupCallback,
            setInputValue,
            setRecentList,
        });
    };
    const onInputChange = (e) => {
        checkStack.push(e.target.value);
        if (checkStack.length >= 3 &&
            hangul.isComplete(checkStack[checkStack.length - 1]) &&
            hangul.isComplete(checkStack[checkStack.length - 3]) &&
            checkStack[checkStack.length - 1] === checkStack[checkStack.length - 3]) {
            checkStack = [];
            setTimeout(() => {
                updateValue(e.target.value);
            }, userAgent === "mac safari" ? 25 : 1);
        }
        else {
            updateValue(e.target.value);
        }
        setInputValue(e.target.value);
    };
    const onSearch = (e) => {
        if (!e.repeat && e.key === "Enter") {
            e.currentTarget.blur();
            if (!inputValue) {
                arroundSearchFn();
                return;
            }
            setInputValue(inputValue);
            setFocus(false);
            window.location.href = (0, urlHandler_1.setQueryParams)({ query: inputValue }, (0, getLocationTo_1.default)());
            (0, recentSearchList_1.setRecentSearchList)({
                type: "query",
                content: inputValue,
                query: inputValue,
            }, setRecentList);
            // 검색 후 팝업을 닫습니다.
            // setPopup((prev:any) => ({ ...prev, searchPopup: 0 }));
            return;
        }
    };
    const onClick = (e) => {
        setFocus(true);
        if (initValue === inputValue && e._reactName !== "onFocus") {
            if (!inputValue)
                return;
            if (!e.currentTarget.value)
                return;
            if (isInitAutoValue)
                return;
            isInitAutoValue = true;
            updateValue(initValue, true);
        }
        const $root = document.body.querySelector("#root");
        if (!$root)
            return;
        $root.scrollTo(0, 0);
        window.scrollTo(0, 0);
        document.body.scrollTo(0, 0);
    };
    const onBlur = (e) => {
        isInitAutoValue = false;
    };
    const onKeyDown = (e) => {
        if (e.nativeEvent.isComposing)
            return;
        if (!focus) {
            setFocus(true);
        }
        (0, inputKeyDownHandler_1.onInputKeyDown)({ e, setFocus, setInputValue });
    };
    return ((0, jsx_runtime_1.jsx)(Input, { inputValue: inputValue, inputRef: inputRef, onBlur: onBlur, onClick: onClick, onInputChange: onInputChange, onSearch: onSearch, onKeyDown: onKeyDown }));
};
const Input = react_1.default.memo(({ inputValue, inputRef, onClick, onBlur, onInputChange, onSearch, onKeyDown, }) => {
    return ((0, jsx_runtime_1.jsx)(StyledRecoilUsedInput_1.SearchInputBox, { className: "Search__Input", 
        // maxLength={40}
        value: inputValue, placeholder: "\uC9C0\uC5ED, \uC74C\uC2DD \uB610\uB294 \uC2DD\uB2F9\uBA85 \uC785\uB825", onChange: onInputChange, onFocus: onClick, onClick: onClick, onBlur: onBlur, onKeyPress: onSearch, onKeyDown: onKeyDown, ref: inputRef }));
});
const RemoveCtx = () => {
    const { isInputExist, inputRef } = (0, useContextAPI_1.useValueContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderValueCtx);
    const { setInputValue, setFocus, setAutoValue } = (0, useContextAPI_1.useSetContext)(CommonDeskHeaderProvider_1.CommonDeskHeaderDispatcherCtx);
    const onRemoveClick = () => {
        setFocus(true);
        setInputValue("");
        setAutoValue({ rest: null, keyword: null });
        isInitAutoValue = false;
        if (!inputRef.current)
            return;
        inputRef.current.focus();
    };
    return ((0, jsx_runtime_1.jsx)(Remove, { isInputExist: isInputExist, "$input": inputRef.current, setInputValue: setInputValue, onRemoveClick: onRemoveClick, setFocus: setFocus }));
};
const Remove = react_1.default.memo(({ isInputExist, setInputValue, setFocus, onRemoveClick, }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isInputExist && ((0, jsx_runtime_1.jsx)(StyledRecoilUsedInput_1.SearchModalRemoveButton, { className: "Search__Remove__Button", onClick: onRemoveClick, onClickCapture: (e) => {
                e.preventDefault();
            }, children: (0, jsx_runtime_1.jsx)("img", { id: "DeleteImg", src: imageUrl_1.search_input.delete_img, alt: "\uAC80\uC0C9\uC5B4 \uC9C0\uC6B0\uAE30 \uBC84\uD2BC \uC774\uBBF8\uC9C0" }) })) }));
});
RecoilUsedInput.Box = BoxCtx;
RecoilUsedInput.Modal = ModalCtx;
RecoilUsedInput.SearchBtn = SearchBtnCtx;
RecoilUsedInput.Input = InputCtx;
RecoilUsedInput.Remove = RemoveCtx;
exports.default = RecoilUsedInput;
